import { css } from 'aphrodite/no-important';
import React, { FC } from 'react';
import { style } from './style';

export enum BrandingType {
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
}

export interface BrandingProps {
  // controls if the orientation of the branding is vertical or horizontal (i.e. Logo is on top of the copy for vertical)
  type: string;

  // image src of the logo
  logoUrl: string;

  // text for the branding
  copy: string;

  // Hides/show the entire branding component. This is used to hide this component when the mobile menu nav is open
  isVisible?: boolean;

  // Allows the copy to be hidden when on centain break points to give more space to the rest of the nav
  isCopyStatic?: boolean;
}
export const Branding: FC<BrandingProps> = ({ type, logoUrl, copy, isVisible = true, isCopyStatic = true }) => {
  const styles = style({ type, isCopyStatic });
  return (
    <div className={`${css(styles.brandingContainer)} ${!isVisible ? css(styles.hiddenBranding) : ''}`}>
      <figure className={css(styles.logo)}>
        <img src={logoUrl} alt='TSMC Logo' />
      </figure>
      <p className={css(styles.copy)} dangerouslySetInnerHTML={{ __html: copy }} />
    </div>
  );
};
